import { cva, type VariantProps } from 'class-variance-authority';
import { ILLUSTRATION, IllustrationName } from './_generated/illustrations.registry';
import { createFigmaComponent } from './createFigmaComponent';

const illustrationVariants = cva('inline-block', {
  variants: {
    size: {
      sm: 'w-36 h-36',
      md: 'w-44 h-44',
      lg: 'w-52 h-52',
      xl: 'w-64 h-64',
    },
  },
  defaultVariants: { size: 'md' },
});

const BaseComponent = createFigmaComponent<IllustrationName, VariantProps<typeof illustrationVariants>>(
  ILLUSTRATION,
  illustrationVariants,
  'TbIllustration'
);

/**
 * Renders a lazy-loaded SVG TbIllustration exported directly from Figma.
 * * Use this for larger graphics like empty states, banners, or hero images.
 * It fully supports autocomplete for illustration names and predefined sizes.
 *
 * @example
 * // Standard usage:
 * <TbIllustration name="Empty_Cart_State" size="lg" />
 * * // Custom styling (overriding the default size):
 * <TbIllustration
 * name="Success_Checkmark"
 * className="w-full max-w-md mx-auto drop-shadow-lg"
 * />
 */

export type TbIllustrationProps = React.ComponentProps<typeof BaseComponent> &
  Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'>;

export const TbIllustration = BaseComponent as React.FC<TbIllustrationProps>;
